import request from '../../../helpers/request';

const deleteFlatAttachment = async (addressId, attachId) => {
  const response = await request.delete(
    `/HousingStock/address/${addressId}/attachment`,
    {
      attachId,
    },
    'Не удалось удалить документ'
  );

  return response;
};

export default deleteFlatAttachment;
